export enum OrderItemStatus {
  PENDING = 'PENDING', // En cola
  IN_PREPARATION = 'IN_PREPARATION', // En preparación
  READY = 'READY', // Listo
  DELIVERED = 'DELIVERED', // Entregado
  CANCELLED = 'CANCELLED', // Cancelado
}

export const ORDER_ITEM_STATUS_LABELS = {
  [OrderItemStatus.PENDING]: 'En cola',
  [OrderItemStatus.IN_PREPARATION]: 'En preparación',
  [OrderItemStatus.READY]: 'Listo',
  [OrderItemStatus.DELIVERED]: 'Entregado',
  [OrderItemStatus.CANCELLED]: 'Cancelado',
};
